import ASSETS_PATHS from "../storiesAssets";

export const translations = {
  English: {
    items: [
      {
        id: "truffleTangles",
        url: ASSETS_PATHS.videos.truffleTangles,
        title: "Truffle tangles by ILA",
        location: "Gurugram, Haryana",
        tagline: "From homemade treats to seamless online sales—WhatsApp Business helped working-from-home entrepreneur, Ila sell 80–100 birthday cakes a month",
        category: "tools",
        poster: ASSETS_PATHS.truffleTanglesImg,
        backToSuccessStories: "Back to Success Stories"
      },
      {
        id: "shoeDoctor",
        url: ASSETS_PATHS.videos.shoeDoctor,
        title: "Shoe Doctor",
        location: "Uttam Nagar, New Delhi",
        tagline: "From worn-out soles to restored steps— Anuj & Ajit’s business service sales grew by 75% using WhatsApp Business' affordable digital tools tailored for India's SMBs",
        category: "ads",
        poster: ASSETS_PATHS.shoeDoctorImg,
        backToSuccessStories: "Back to Success Stories"
      },
      {
        id: "savvyTree",
        url: ASSETS_PATHS.videos.savvyTree,
        title: "Savvytree",
        location: "Chhatarpur, New Delhi",
        tagline: "From chats to conversions— Tanya, Bharat and Chirag improved digital marketing results for high-end businesses by 10-15% using WhatsApp ads strategies",
        category: "ads",
        poster: ASSETS_PATHS.savvyTreeImg,
        backToSuccessStories: "Back to Success Stories"
      },
      {
        id: "singhsPhotoByShaan",
        url: ASSETS_PATHS.videos.singhsPhotoByShaan,
        title: "Singh's Foto by Shaan",
        location: "Varanasi",
        tagline: "From small pre-wedding shoots to stellar events—Shaan increased service bookings by 50-60% using WhatsApp Business' customer communication tools",
        category: "tools",
        poster: ASSETS_PATHS.singhsPhotoByShaanImg,
        backToSuccessStories: "Back to Success Stories"
      },
      {
        id: "celebrationCompany",
        url: ASSETS_PATHS.videos.celebrationCompany,
        title: "The Celebration Company",
        location: "Varanasi",
        tagline: "From first wishes to applause—WhatsApp Business helped Honey boost business sales by 60-70%",
        category: "tools",
        poster: ASSETS_PATHS.celebrationCompanyImg,
        backToSuccessStories: "Back to Success Stories"
      },
      {
        id: "travelConnection",
        url: ASSETS_PATHS.videos.travelConnection,
        title: "Travel Connection",
        location: "Dabri, New Delhi",
        tagline: "From dream trips to quick bookings—Harpreet and  Himanshu secured 1,744+ business leads in 8 months using WhatsApp for business communication",
        category: "ads",
        poster: ASSETS_PATHS.travelConnectionImg,
        backToSuccessStories: "Back to Success Stories"
      },
      {
        id: "automen",
        url: ASSETS_PATHS.videos.automen,
        title: "Automen",
        location: "Ghittorni, New Delhi",
        tagline: "From long waits to doorstep care—70-80% of Vineet’s business growth accelerated through WhatsApp Business support",
        category: "tools",
        poster: ASSETS_PATHS.automenImg,
        backToSuccessStories: "Back to Success Stories"
      },
      {
        id: "letsRyde",
        url: ASSETS_PATHS.videos.letsRyde,
        title: "Lets Ryde",
        location: "Gurugram, Haryana",
        tagline: "From first rides to bold transformations— Amit trains 400+ women riders monthly and grew his business by 15-20% using WhatsApp Business for local promotion",
        category: "ads",
        poster: ASSETS_PATHS.letsRydeImg,
        backToSuccessStories: "Back to Success Stories"
      },
      {
        id: "modelloDomani",
        url: ASSETS_PATHS.videos.modelloDomani,
        title: "Mondello Domani",
        location: "Lajpat Nagar, New Delhi",
        tagline: "Ayush brought Indian craftsmanship global with WhatsApp Business—boosting sales by 25% through online catalog promotion",
        category: "tools",
        poster: ASSETS_PATHS.modelloDomaniImg,
        backToSuccessStories: "Back to Success Stories"
      },
    ],
    bannerHeading: `Empowering service providers </br> and digital shops across Bharat`,
    bannerText: `WhatsApp Business brings growth within reach through tools like </br>
      <span class="underline decoration-[#00D084] underline-offset-4">ads that click to WhatsApp</span>, 
      <span class="underline decoration-[#00D084] underline-offset-4">catalogs</span>, and 
      <span class="underline decoration-[#00D084] underline-offset-4">labels</span></br>
      now with the added trust of 
      <span class="underline decoration-[#00D084] underline-offset-4">Meta Verified</span>`,
    filterOptions: [
      { label: "All", value: "all" },
      { label: "Ads that click to WhatsApp", value: "ads" },
      { label: "WhatsApp business tools", value: "tools" },
    ],
    successStoriesTitle: "Explore Success Stories"
  },
  हिंदी: {
    items: [
      {
        id: "truffleTangles",
        url: ASSETS_PATHS.hindiVideos.truffleTangles,
        title: "Truffle tangles by ILA",
        location: "Gurugram, Haryana",
        tagline: "घर के बने स्वादिष्ट व्यंजनों से लेकर आसान ऑनलाइन बिक्री तक—WhatsApp Busniess ने घर से काम करने वाली उद्यमी इला को हर महीने 80-100 बर्थडे केक बेचने में सहायता की।",
        category: "tools",
        poster: ASSETS_PATHS.truffleTanglesImg,
        backToSuccessStories: "पिछला पृष्ठ"
      },
      {
        id: "shoeDoctor",
        url: ASSETS_PATHS.hindiVideos.shoeDoctor,
        title: "Shoe Doctor",
        location: "Uttam Nagar, New Delhi",
        tagline: "घिसे हुए पांव से लेकर फिर से संभले कदमों तक — अनुज और अजीत की व्यापार सेवा की बिक्री WhatsApp Business के भारत के छोटे कारोबारियों के लिए बनाए गए किफायती डिजिटल टूल्स की मदद से 75% तक बढ़ी।",
        category: "ads",
        poster: ASSETS_PATHS.shoeDoctorImg,
        backToSuccessStories: "पिछला पृष्ठ"
      },
      {
        id: "savvyTree",
        url: ASSETS_PATHS.hindiVideos.savvyTree,
        title: "Savvytree",
        location: "Chhatarpur, New Delhi",
        tagline: "बातचीत से लेकर रूपांतरण तक - तन्या, भरत और चिराग ने WhatsApp Ads रणनीतियों से उन्नत व्यवसायों के डिजिटल मार्केटिंग नतीजे 10–15% तक बेहतर किए।",
        category: "ads",
        poster: ASSETS_PATHS.savvyTreeImg,
        backToSuccessStories: "पिछला पृष्ठ"
      },
      {
        id: "singhsPhotoByShaan",
        url: ASSETS_PATHS.hindiVideos.singhsPhotoByShaan,
        title: "Singh's Foto by Shaan",
        location: "Varanasi",
        tagline: "छोटे प्री-वेडिंग शूट से लेकर भव्य इवेंट्स तक — शान ने WhatsApp Business के ग्राहक संवाद टूल्स की मदद से अपनी सेवा बुकिंग में 50–60% तक बढ़ोतरी की।",
        category: "tools",
        poster: ASSETS_PATHS.singhsPhotoByShaanImg,
        backToSuccessStories: "पिछला पृष्ठ"
      },
      {
        id: "celebrationCompany",
        url: ASSETS_PATHS.hindiVideos.celebrationCompany,
        title: "The Celebration Company",
        location: "Varanasi",
        tagline: "पहली शुभकामनाओं से लेकर तालियों तक—WhatsApp Businessने हनी को व्यवसाय की बिक्री 60-70% तक बढ़ाने में मदद की।",
        category: "tools",
        poster: ASSETS_PATHS.celebrationCompanyImg,
        backToSuccessStories: "पिछला पृष्ठ"
      },
      {
        id: "travelConnection",
        url: ASSETS_PATHS.hindiVideos.travelConnection,
        title: "Travel Connection",
        location: "Dabri, New Delhi",
        tagline: "सपनों की यात्राओं से लेकर झटपट बुकिंग तक — हरप्रीत और हिमांशु ने WhatsApp का इस्तेमाल कर 8 महीनों में 1,744 से ज़्यादा बिज़नेस लीड्स हासिल कीं।",
        category: "ads",
        poster: ASSETS_PATHS.travelConnectionImg,
        backToSuccessStories: "पिछला पृष्ठ"
      },
      {
        id: "automen",
        url: ASSETS_PATHS.hindiVideos.automen,
        title: "Automen",
        location: "Ghittorni, New Delhi",
        tagline: "लंबे इंतजार से लेकर घर तक सेवा—WhatsApp Business सपोर्ट की मदद से विनीत के व्यवसाय में 70-80% तक तेजी से बढ़ोतरी हुई।",
        category: "tools",
        poster: ASSETS_PATHS.automenImg,
        backToSuccessStories: "पिछला पृष्ठ"
      },
      {
        id: "letsRyde",
        url: ASSETS_PATHS.hindiVideos.letsRyde,
        title: "Lets Ryde",
        location: "Gurugram, Haryana",
        tagline: "पहली सवारी से लेकर बड़े बदलाव तक—अमित हर महीने 400 से ज्यादा महिला राइडर्स को ट्रेनिंग देते हैं और WhatsApp Business के ज़रिए स्थानीय प्रचार कर के अपने व्यवसाय  में 15-20% की बढ़ोतरी की है।",
        category: "ads",
        poster: ASSETS_PATHS.letsRydeImg,
        backToSuccessStories: "पिछला पृष्ठ"
      },
      {
        id: "modelloDomani",
        url: ASSETS_PATHS.hindiVideos.modelloDomani,
        title: "Mondello Domani",
        location: "Lajpat Nagar, New Delhi",
        tagline: "आयुष ने WhatsApp Business के जरिए भारतीय शिल्पकला को वैश्विक स्तर पर पहुंचाया—ऑनलाइन कैटलॉग प्रमोशन के माध्यम से बिक्री में 25% की बढ़ोतरी की।",
        category: "tools",
        poster: ASSETS_PATHS.modelloDomaniImg,
        backToSuccessStories: "पिछला पृष्ठ"
      },
    ],
    bannerHeading: `भारत के हर कोने में सेवा </br> और डिजिटल कारोबार को मजबूती`,
    bannerText: `<span class="underline decoration-[#00D084] underline-offset-4">ऐड्स दैट क्लिक टू WhatsApp</span>, 
      <span class="underline decoration-[#00D084] underline-offset-4">कैटलॉग</span> और 
      <span class="underline decoration-[#00D084] underline-offset-4">लेबल</span></br>
      जैसे टूल्स के ज़रिए Whatsapp Business बढ़त को आसान बनाता है- और अब इसमें </br>
      <span class="underline decoration-[#00D084] underline-offset-4">Meta वेरिफ़ाइड</span> 
      का भरोसा भी शामिल है।`,
    filterOptions: [
      { label: "सभी", value: "all" },
      { label: "ऐड्स दैट क्लिक टू WhatsApp", value: "ads" },
      { label: "WhatsApp Business टूल्स", value: "tools" },
    ],
    successStoriesTitle: "सफलता की कहानियां देखें"
  },
  मराठी: {
    items: [
      {
        id: "truffleTangles",
        url: ASSETS_PATHS.marathiVideos.truffleTangles,
        title: "Truffle tangles by ILA",
        location: "Gurugram, Haryana",
        tagline: "घरगुती पदार्थांपासून ते अखंड ऑनलाइन विक्रीपर्यंत - WhatsApp Business घरून काम करणाऱ्या उद्योजकाला मदत केली, तो महिन्याला ८०-१०० वाढदिवसाचे केक विकतो",
        category: "tools",
        poster: ASSETS_PATHS.truffleTanglesImg,
        backToSuccessStories: "मागील पृष्ठ"
      },
      {
        id: "shoeDoctor",
        url: ASSETS_PATHS.marathiVideos.shoeDoctor,
        title: "Shoe Doctor",
        location: "Uttam Nagar, New Delhi",
        tagline: "झिजलेल्या पावलांपासून पुनर्बांधलेल्या पावलांपर्यंत — अनुज आणि अजित यांच्या व्यवसाय सेवांच्या विक्रीत 75% वाढ झाली,WhatsApp Business परवडणाऱ्या डिजिटल साधनांचा वापर भारतातील एसएमबीएससाठी तयार केलेल्या",
        category: "ads",
        poster: ASSETS_PATHS.shoeDoctorImg,
        backToSuccessStories: "मागील पृष्ठ"
      },
      {
        id: "savvyTree",
        url: ASSETS_PATHS.marathiVideos.savvyTree,
        title: "Savvytree",
        location: "Chhatarpur, New Delhi",
        tagline: "चॅट्सपासून ते रूपांतरणांपर्यंत - तान्या, भरत आणि चिराग यांनी WhatsApp जाहिरातींच्या धोरणांचा वापर करून उच्च श्रेणीतील व्यवसायांसाठी डिजिटल मार्केटिंग निकालांमध्ये १०-१५% सुधारणा केली.",
        category: "ads",
        poster: ASSETS_PATHS.savvyTreeImg,
        backToSuccessStories: "मागील पृष्ठ"
      },
      {
        id: "singhsPhotoByShaan",
        url: ASSETS_PATHS.marathiVideos.singhsPhotoByShaan,
        title: "Singh's Foto by Shaan",
        location: "Varanasi",
        tagline: "लग्नापूर्वीच्या छोट्या शूटिंगपासून ते उत्कृष्ट कार्यक्रमांपर्यंत - शानने सेवा वाढवली बुकिंगमध्ये ५०-६०% वाढ WhatsApp Business ग्राहक संवाद साधनांचा वापर करून",
        category: "tools",
        poster: ASSETS_PATHS.singhsPhotoByShaanImg,
        backToSuccessStories: "मागील पृष्ठ"
      },
      {
        id: "celebrationCompany",
        url: ASSETS_PATHS.marathiVideos.celebrationCompany,
        title: "The Celebration Company",
        location: "Varanasi",
        tagline: "पहिल्या शुभेच्छांपासून ते टाळ्यांपर्यंत - WhatsApp Business हनीला चालना देण्यास मदत केली व्यवसाय विक्रीत ६०-७०% वाढ",
        category: "tools",
        poster: ASSETS_PATHS.celebrationCompanyImg,
        backToSuccessStories: "मागील पृष्ठ"
      },
      {
        id: "travelConnection",
        url: ASSETS_PATHS.marathiVideos.travelConnection,
        title: "Travel Connection",
        location: "Dabri, New Delhi",
        tagline: "स्वप्नातील प्रवासांपासून ते झपाट्याने होणाऱ्या बुकिंगपर्यंत — हरप्रीत आणि हिमांशू यांनी व्यवसायिक संवादासाठी WhatsApp वापरून ८ महिन्यांत १,७४४+ व्यवसाय लीड्स मिळवले.",
        category: "ads",
        poster: ASSETS_PATHS.travelConnectionImg,
        backToSuccessStories: "मागील पृष्ठ"
      },
      {
        id: "automen",
        url: ASSETS_PATHS.marathiVideos.automen,
        title: "Automen",
        location: "Ghittorni, New Delhi",
        tagline: "लांब प्रतीक्षेतून घरपोच सेवेकडे —70–80% नी वेग आला. विनीतच्या व्यवसायाच्या वाढीत WhatsApp Business सहाय्याने",
        category: "tools",
        poster: ASSETS_PATHS.automenImg,
        backToSuccessStories: "मागील पृष्ठ"
      },
      {
        id: "letsRyde",
        url: ASSETS_PATHS.marathiVideos.letsRyde,
        title: "Lets Ryde",
        location: "Gurugram, Haryana",
        tagline: "पहिल्या राईडपासून धाडसी परिवर्तनांपर्यंत — अमित दरमहा ४००+ महिला रायडर्सना प्रशिक्षण देतो आणि स्थानिक प्रचारासाठी WhatsApp Business वापरून आपल्या व्यवसायात १५-२०% ने वाढवतो",
        category: "ads",
        poster: ASSETS_PATHS.letsRydeImg,
        backToSuccessStories: "मागील पृष्ठ"
      },
      {
        id: "modelloDomani",
        url: ASSETS_PATHS.marathiVideos.modelloDomani,
        title: "Mondello Domani",
        location: "Lajpat Nagar, New Delhi",
        tagline: "आयुषने आणली भारतीय कारागिरीला जागतिक स्तरावर नेले माध्यमातून WhatsApp Business विक्रीत २५% वाढ झाली ऑनलाइन कॅटलॉग प्रमोशनद्वारे",
        category: "tools",
        poster: ASSETS_PATHS.modelloDomaniImg,
        backToSuccessStories: "मागील पृष्ठ"
      },
    ],
    bannerHeading: `संपूर्ण भारतातील सेवा प्रदाते </br> आणि डिजिटल दुकानांना सक्षम बनवणे`,
    bannerText: `WhatsApp Business टूल्सद्वारे वाढ तुमच्या आवाक्यात आणतो.जसे कि </br>
      <span class="underline decoration-[#00D084] underline-offset-4">क्लिक टू WhatsApp एड्स</span>, 
      <span class="underline decoration-[#00D084] underline-offset-4">कॅटलॉग</span>, आणि 
      <span class="underline decoration-[#00D084] underline-offset-4">लेबल्स</span></br>
      आत्ता
      <span class="underline decoration-[#00D084] underline-offset-4">Meta व्हेरिफाइडच्या</span> अतिरिक्त विश्वासासह`,
    filterOptions: [
      { label: "सर्व", value: "all" },
      { label: "एड्स द्यात क्लिक टू WhatsApp", value: "ads" },
      { label: "WhatsApp Business टूल्स", value: "tools" },
    ],
    successStoriesTitle: "यशोगाथा एक्सप्लोर करा"
  },
  বাংলা: {
    items: [
      {
        id: "truffleTangles",
        url: ASSETS_PATHS.bengaliVideos.truffleTangles,
        title: "Truffle tangles by ILA",
        location: "Gurugram, Haryana",
        tagline: "ঘরে তৈরি সুস্বাদু খাবার থেকে শুরু করে নির্বিঘ্ন অনলাইন বিক্রয় পর্যন্ত—WhatsApp Business ওয়ার্কিং-ফ্রম-হোম উদ্যোক্তা ইলাকে মাসে ৮০-১০০টি জন্মদিনের কেক বিক্রি করতে সাহায্য করেছে",
        category: "tools",
        poster: ASSETS_PATHS.truffleTanglesImg,
        backToSuccessStories: "আগের পৃষ্ঠা"
      },
      {
        id: "shoeDoctor",
        url: ASSETS_PATHS.bengaliVideos.shoeDoctor,
        title: "Shoe Doctor",
        location: "Uttam Nagar, New Delhi",
        tagline: "জীর্ণ জুতো থেকে পুনরুদ্ধার করা পদক্ষেপ পর্যন্ত—অনুজ ও অজিতের ব্যবসা পরিষেবার বিক্রয় ৭৫% বৃদ্ধি পেয়েছে WhatsApp Business সাশ্রয়ী ডিজিটাল সরঞ্জাম ব্যবহার করে, যা ভারতের ছোট ও মাঝারি ব্যবসার জন্য বিশেষভাবে তৈরি",
        category: "ads",
        poster: ASSETS_PATHS.shoeDoctorImg,
        backToSuccessStories: "আগের পৃষ্ঠা"
      },
      {
        id: "savvyTree",
        url: ASSETS_PATHS.bengaliVideos.savvyTree,
        title: "Savvytree",
        location: "Chhatarpur, New Delhi",
        tagline: "চ্যাট থেকে বিক্রয় রূপান্তর পর্যন্ত—তানিয়া, ভারত এবং চিরাগ WhatsApp বিজ্ঞাপনের কৌশল ব্যবহার করে উচ্চমানের ব্যবসাগুলির ডিজিটাল মার্কেটিং এর মাধ্যমে ১০-১৫% বৃদ্ধি করেছেন",
        category: "ads",
        poster: ASSETS_PATHS.savvyTreeImg,
        backToSuccessStories: "আগের পৃষ্ঠা"
      },
      {
        id: "singhsPhotoByShaan",
        url: ASSETS_PATHS.bengaliVideos.singhsPhotoByShaan,
        title: "Singh's Foto by Shaan",
        location: "Varanasi",
        tagline: "ছোট প্রি-ওয়েডিং শুট থেকে জমকালো ইভেন্ট পর্যন্ত—শান WhatsApp Business গ্রাহক যোগাযোগ সরঞ্জাম ব্যবহার করে তার পরিষেবার বুকিং ৫০-৬০% বৃদ্ধি করেছেন",
        category: "tools",
        poster: ASSETS_PATHS.singhsPhotoByShaanImg,
        backToSuccessStories: "আগের পৃষ্ঠা"
      },
      {
        id: "celebrationCompany",
        url: ASSETS_PATHS.bengaliVideos.celebrationCompany,
        title: "The Celebration Company",
        location: "Varanasi",
        tagline: "প্রথম শুভেচ্ছা থেকে শুরু করে প্রশংসা পর্যন্ত—WhatsApp  Business হানিকে ব্যবসার বিক্রয় ৬০-৭০% বাড়াতে সাহায্য করেছে",
        category: "tools",
        poster: ASSETS_PATHS.celebrationCompanyImg,
        backToSuccessStories: "আগের পৃষ্ঠা"
      },
      {
        id: "travelConnection",
        url: ASSETS_PATHS.bengaliVideos.travelConnection,
        title: "Travel Connection",
        location: "Dabri, New Delhi",
        tagline: "স্বপ্নের ভ্রমণ থেকে দ্রুত বুকিং পর্যন্ত—হরপ্রীত এবং হিমাংশু ব্যবসার যোগাযোগের জন্য WhatsApp ব্যবহার করে ৮ মাসে ১,৭৪৪+ ব্যবসায়িক লিড সুরক্ষিত করেছেন",
        category: "ads",
        poster: ASSETS_PATHS.travelConnectionImg,
        backToSuccessStories: "আগের পৃষ্ঠা"
      },
      {
        id: "automen",
        url: ASSETS_PATHS.bengaliVideos.automen,
        title: "Automen",
        location: "Ghittorni, New Delhi",
        tagline: "দীর্ঘ অপেক্ষা থেকে দোরগোড়ায় পরিষেবা পর্যন্ত—বিনীতের ব্যবসার ৭০-৮০% বৃদ্ধি WhatsApp Business সাপোর্টের মাধ্যমে ত্বরান্বিত হয়েছে",
        category: "tools",
        poster: ASSETS_PATHS.automenImg,
        backToSuccessStories: "আগের পৃষ্ঠা"
      },
      {
        id: "letsRyde",
        url: ASSETS_PATHS.bengaliVideos.letsRyde,
        title: "Lets Ryde",
        location: "Gurugram, Haryana",
        tagline: "প্রথম রাইড থেকে বড় পরিবর্তন পর্যন্ত—অমিত প্রতি মাসে ৪০০+ মহিলা রাইডারকে প্রশিক্ষণ দেন এবং স্থানীয় প্রচারের জন্য WhatsApp Business ব্যবহার করে তার ব্যবসা ১৫-২০% বাড়িয়েছেন",
        category: "ads",
        poster: ASSETS_PATHS.letsRydeImg,
        backToSuccessStories: "আগের পৃষ্ঠা"
      },
      {
        id: "modelloDomani",
        url: ASSETS_PATHS.bengaliVideos.modelloDomani,
        title: "Mondello Domani",
        location: "Lajpat Nagar, New Delhi",
        tagline: "আয়ুষ WhatsApp Business মাধ্যমে ভারতীয় কারুশিল্পকে বিশ্বজুড়ে পৌঁছে দিয়েছেন—অনলাইন ক্যাটালগ প্রচারের মাধ্যমে বিক্রি ২৫% বাড়িয়েছেন",
        category: "tools",
        poster: ASSETS_PATHS.modelloDomaniImg,
        backToSuccessStories: "আগের পৃষ্ঠা"
      },
    ],
    bannerHeading: `ভারত জুড়ে পরিষেবা প্রদানকারী </br> এবং ডিজিটাল দোকানগুলিকে শক্তিশালী করা`,
    bannerText: `WhatsApp Business ক্লিক টু WhatsApp 
      <span class="underline decoration-[#00D084] underline-offset-4">বিজ্ঞাপন</span>, 
      <span class="underline decoration-[#00D084] underline-offset-4">ক্যাটালগ</span>, এবং 
      <span class="underline decoration-[#00D084] underline-offset-4">লেবেলের</span></br>
      মতো সরঞ্জামগুলির মাধ্যমে ব্যবসার বৃদ্ধিকে হাতের মুঠোয় নিয়ে আসে – এখন 
      <span class="underline decoration-[#00D084] underline-offset-4">Meta ভেরিফায়েডের</span> অতিরিক্ত বিশ্বাসযোগ্যতা সহ`,
    filterOptions: [
      { label: "সবাই", value: "all" },
      { label: "এডস দ্যাট ক্লিক টু WhatsApp", value: "ads" },
      { label: "WhatsApp Business টুলস", value: "tools" },
    ],
    successStoriesTitle: "সাফল্যের গল্পগুলি অন্বেষণ করুন"
  },
  தமிழ்: {
    items: [
      {
        id: "truffleTangles",
        url: ASSETS_PATHS.tamilVideos.truffleTangles,
        title: "Truffle tangles by ILA",
        location: "Gurugram, Haryana",
        tagline: "வீட்டில் செய்யும் சிறிய உணவுப் பொருட்களிலிருந்து ஆன்லைனில் எளிதாக விற்பனை — இலா, WhatsApp Business மூலம் வீட்டிலிருந்து பணிபுரிந்து மாதம் 80–100 பிறந்த நாள் கேக்குகளை விற்பனை செய்கிறார்.",
        category: "tools",
        poster: ASSETS_PATHS.truffleTanglesImg,
        backToSuccessStories: "முந்தைய பக்கம்"
      },
      {
        id: "shoeDoctor",
        url: ASSETS_PATHS.tamilVideos.shoeDoctor,
        title: "Shoe Doctor",
        location: "Uttam Nagar, New Delhi",
        tagline: "தேய்ந்து போன உள்ளங்கால்கள் முதல் மீட்டெடுக்கப்பட்ட பாதைகள் வரை— இந்தியாவின் SMB-களுக்காக வடிவமைக்கப்பட்ட WhatsApp Business-இன் மலிவு விலை டிஜிட்டல் கருவிகளைப் பயன்படுத்தி அனுஜ் & அஜித்தின் வணிக சேவை விற்பனை 75% அதிகரித்துள்ளது.",
        category: "ads",
        poster: ASSETS_PATHS.shoeDoctorImg,
        backToSuccessStories: "முந்தைய பக்கம்"
      },
      {
        id: "savvyTree",
        url: ASSETS_PATHS.tamilVideos.savvyTree,
        title: "Savvytree",
        location: "Chhatarpur, New Delhi",
        tagline: "அரட்டைகள் முதல் மாற்றங்கள் வரை — டான்யா, பாரத் & சிராக், WhatsApp விளம்பர தந்திரங்களைப் பயன்படுத்தி உயர் தர வியாபாரங்களுக்கான டிஜிட்டல் மார்க்கெட்டிங் முடிவுகளை 10–15% வரை மேம்படுத்தினர்.",
        category: "ads",
        poster: ASSETS_PATHS.savvyTreeImg,
        backToSuccessStories: "முந்தைய பக்கம்"
      },
      {
        id: "singhsPhotoByShaan",
        url: ASSETS_PATHS.tamilVideos.singhsPhotoByShaan,
        title: "Singh's Foto by Shaan",
        location: "Varanasi",
        tagline: "சிறிய ஷூட்டிங்கில் இருந்து பிரமாண்ட நிகழ்வுகள் வரை — ஷான், WhatsApp Business வாடிக்கையாளர் தொடர்பு சேவை கருவிகளைப் பயன்படுத்தி, சேவை முன்பதிவுகளை 50–60% வரை அதிகரித்தார்.",
        category: "tools",
        poster: ASSETS_PATHS.singhsPhotoByShaanImg,
        backToSuccessStories: "முந்தைய பக்கம்"
      },
      {
        id: "celebrationCompany",
        url: ASSETS_PATHS.tamilVideos.celebrationCompany,
        title: "The Celebration Company",
        location: "Varanasi",
        tagline: "முதல் வாழ்த்துகளிலிருந்து பாராட்டுகள் மழை வரை – ஹனி, வணிக விற்பனை 60–70% அதிகரித்தது WhatsApp Business உதவியுடன்!",
        category: "tools",
        poster: ASSETS_PATHS.celebrationCompanyImg,
        backToSuccessStories: "முந்தைய பக்கம்"
      },
      {
        id: "travelConnection",
        url: ASSETS_PATHS.tamilVideos.travelConnection,
        title: "Travel Connection",
        location: "Dabri, New Delhi",
        tagline: "கனவு பயணங்களிலிருந்து முன்பதிவுகள் வரை – ஹர்ப்ரீத் & ஹிமாஷு 8 மாதங்களில் 1,744+ வணிக முன்னோட்டங்களைப் பெற்றனர், WhatsApp Business உதவியுடன்!",
        category: "ads",
        poster: ASSETS_PATHS.travelConnectionImg,
        backToSuccessStories: "முந்தைய பக்கம்"
      },
      {
        id: "automen",
        url: ASSETS_PATHS.tamilVideos.automen,
        title: "Automen",
        location: "Ghittorni, New Delhi",
        tagline: "நீண்ட காத்திருப்பு முதல் வீட்டு வாசலில் பராமரிப்பு வரை—WhatsApp Business ஆதரவு மூலம் வினீத்தின் வணிக வளர்ச்சியில் 70-80% துரிதப்படுத்தப்பட்டது.",
        category: "tools",
        poster: ASSETS_PATHS.automenImg,
        backToSuccessStories: "முந்தைய பக்கம்"
      },
      {
        id: "letsRyde",
        url: ASSETS_PATHS.tamilVideos.letsRyde,
        title: "Lets Ryde",
        location: "Gurugram, Haryana",
        tagline: "முதல் சவாரிகள் முதல் துணிச்சலான மாற்றங்கள் வரை— அமித் மாதந்தோறும் 400+ பெண் ரைடர்களுக்கு பயிற்சி அளித்து, உள்ளூர் விளம்பரத்திற்காக WhatsApp Business பயன்படுத்தி தனது வணிகத்தை 15-20% வரை வளர்த்தார்.",
        category: "ads",
        poster: ASSETS_PATHS.letsRydeImg,
        backToSuccessStories: "முந்தைய பக்கம்"
      },
      {
        id: "modelloDomani",
        url: ASSETS_PATHS.tamilVideos.modelloDomani,
        title: "Mondello Domani",
        location: "Lajpat Nagar, New Delhi",
        tagline: "ஆயுஷ் WhatsApp Business மூலம் இந்திய கைவினைத்திறனை உலகளவில் கொண்டு சென்றார் - ஆன்லைன் பட்டியல் விளம்பரம் மூலம் விற்பனையை 25% அதிகரித்தது.",
        category: "tools",
        poster: ASSETS_PATHS.modelloDomaniImg,
        backToSuccessStories: "முந்தைய பக்கம்"
      },
    ],
    bannerHeading: `இந்தியா முழுவதும்! <br/> டிஜிட்டல் வியாபார வளர்ச்சி!`,
    bannerText: `WhatsApp Business வளர்ச்சியை எளிதில் கொண்டு வருகிறது <br/>
      WhatsApp-க்கு நேரடியாக கிளிக் செய்யும் 
      <span class="underline decoration-[#00D084] underline-offset-4">விளம்பரங்கள்</span>, 
      <span class="underline decoration-[#00D084] underline-offset-4">பொருட்கள் பட்டியல்</span>, மற்றும் 
      <span class="underline decoration-[#00D084] underline-offset-4">லேபல்கள்</span> போன்ற கருவிகளின் மூலம், இப்போது 
      <span class="underline decoration-[#00D084] underline-offset-4">Meta Verified</span> நம்பகத்தன்மையுடன்.`,
    filterOptions: [
      { label: "அனைத்தும்", value: "all" },
      { label: "ஆட்ஸ் தட் க்ளிக் டூ WhatsApp", value: "ads" },
      { label: "WhatsApp Business டூல்", value: "tools" },
    ],
    successStoriesTitle: "வெற்றி கதைகள் உங்களுக்காக!"
  },
  ગુજરાતી: {
    items: [
      {
        id: "truffleTangles",
        url: ASSETS_PATHS.gujaratiVideos.truffleTangles,
        title: "Truffle tangles by ILA",
        location: "Gurugram, Haryana",
        tagline: "ઘરે બનાવેલી મીઠાઈઓથી લઈને સીમલેસ ઓનલાઈન વેચાણ સુધી - WhatsApp Business ઘરેથી કામ કરતા ઉદ્યોગસાહસિક, ઇલા ને મહિને 80-100 જન્મદિવસની કેક વેચવામાં મદદ કરી",
        category: "tools",
        poster: ASSETS_PATHS.truffleTanglesImg,
        backToSuccessStories: "પાછલું પૃષ્ઠ"
      },
      {
        id: "shoeDoctor",
        url: ASSETS_PATHS.gujaratiVideos.shoeDoctor,
        title: "Shoe Doctor",
        location: "Uttam Nagar, New Delhi",
        tagline: "ઘસાઈ ગયેલા તળિયાથી લઈને પુનઃસ્થાપિત પગથિયાં સુધી- ભારતના એસ એમ બી એસ માટે તૈયાર કરાયેલ WhatsApp Business સસ્તું ડિજિટલ ટૂલ્સનો ઉપયોગ કરીને અનુજ અને અજિતની વ્યવસાયિક સર્વિસના વેચાણમાં 75%નો વધારો થયો છે",
        category: "ads",
        poster: ASSETS_PATHS.shoeDoctorImg,
        backToSuccessStories: "પાછલું પૃષ્ઠ"
      },
      {
        id: "savvyTree",
        url: ASSETS_PATHS.gujaratiVideos.savvyTree,
        title: "Savvytree",
        location: "Chhatarpur, New Delhi",
        tagline: "ચેટ્સથી રૂપાંતરણ સુધી તાન્યા, ભરત અને ચિરાગે WhatsApp જાહેરાત વ્યૂહરચનાઓનો ઉપયોગ કરીને ઉચ્ચ-અંતિમ વ્યવસાયો માટે ડિજિટલ માર્કેટિંગ પરિણામોમાં 10-15% સુધારો કર્યો",
        category: "ads",
        poster: ASSETS_PATHS.savvyTreeImg,
        backToSuccessStories: "પાછલું પૃષ્ઠ"
      },
      {
        id: "singhsPhotoByShaan",
        url: ASSETS_PATHS.gujaratiVideos.singhsPhotoByShaan,
        title: "Singh's Foto by Shaan",
        location: "Varanasi",
        tagline: "નાના પ્રી-વેડિંગ શૂટથી લઈને તારાઓની ઈવેન્ટ્સ સુધી શાને  WhatsApp Business ગ્રાહક સંચાર સાધનોનો ઉપયોગ કરીને સર્વિસ બુકિંગમાં 50-60% વધારો કર્યો",
        category: "tools",
        poster: ASSETS_PATHS.singhsPhotoByShaanImg,
        backToSuccessStories: "પાછલું પૃષ્ઠ"
      },
      {
        id: "celebrationCompany",
        url: ASSETS_PATHS.gujaratiVideos.celebrationCompany,
        title: "The Celebration Company",
        location: "Varanasi",
        tagline: "પ્રથમ શુભેચ્છાઓથી લઈને અભિવાદન સુધી WhatsApp Businessે હનીને 60-70% સુધી Businessના વેચાણમાં વધારો કરવામાં મદદ કરી",
        category: "tools",
        poster: ASSETS_PATHS.celebrationCompanyImg,
        backToSuccessStories: "પાછલું પૃષ્ઠ"
      },
      {
        id: "travelConnection",
        url: ASSETS_PATHS.gujaratiVideos.travelConnection,
        title: "Travel Connection",
        location: "Dabri, New Delhi",
        tagline: "સ્વપ્ન પ્રવાસોથી લઈને ઝડપી બુકિંગ સુધી - હરપ્રીત અને હિમાંશુએ વ્યવસાયિક કોમ્યુનિકેશન માટે WhatsApp નો ઉપયોગ કરીને 8 મહિનામાં 1,744+ વ્યવસાયિક લીડ્સ મેળવ્યા",
        category: "ads",
        poster: ASSETS_PATHS.travelConnectionImg,
        backToSuccessStories: "પાછલું પૃષ્ઠ"
      },
      {
        id: "automen",
        url: ASSETS_PATHS.gujaratiVideos.automen,
        title: "Automen",
        location: "Ghittorni, New Delhi",
        tagline: "લાંબી રાહથી ઘરના દરવાજા સુધીની સંભાળ - વિનીતના વ્યવસાયમાં 70-80% વૃદ્ધિ WhatsApp Business સપોર્ટ દ્વારા ઝડપી બની",
        category: "tools",
        poster: ASSETS_PATHS.automenImg,
        backToSuccessStories: "પાછલું પૃષ્ઠ"
      },
      {
        id: "letsRyde",
        url: ASSETS_PATHS.gujaratiVideos.letsRyde,
        title: "Lets Ryde",
        location: "Gurugram, Haryana",
        tagline: "પહેલી સવારીથી લઈને બોલ્ડ ટ્રાન્સફોર્મેશન સુધી અમિતે દર મહિને 400+ મહિલા રાઇડર્સને તાલીમ આપી અને સ્થાનિક પ્રમોશન માટે WhatsApp Business નો ઉપયોગ કરીને પોતાના વ્યવસાયમાં 15-20% વધારો કર્યો.",
        category: "ads",
        poster: ASSETS_PATHS.letsRydeImg,
        backToSuccessStories: "પાછલું પૃષ્ઠ"
      },
      {
        id: "modelloDomani",
        url: ASSETS_PATHS.gujaratiVideos.modelloDomani,
        title: "Mondello Domani",
        location: "Lajpat Nagar, New Delhi",
        tagline: "આયુષે WhatsApp Business સાથે ભારતીય કારીગરીને વૈશ્વિક સ્તરે લાવ્યા પછી ઓનલાઈન કેટલોગ પ્રમોશન દ્વારા વેચાણમાં 25% વધારો કર્યો",
        category: "tools",
        poster: ASSETS_PATHS.modelloDomaniImg,
        backToSuccessStories: "પાછલું પૃષ્ઠ"
      },
    ],
    bannerHeading: `સમગ્ર ભારતમાં સેવા પ્રદાતાઓ </br> અને ડિજિટલ દુકાનોને સશક્ત બનાવવી`,
    bannerText: `
      <span class="underline decoration-[#00D084] underline-offset-4">ક્લિક ટુ WhatsApp જાહેરાતો</span>, 
      <span class="underline decoration-[#00D084] underline-offset-4">કેટલોગ</span>, અને 
      <span class="underline decoration-[#00D084] underline-offset-4">લેબલ્સ</span></br>
      જેવા ટૂલ્સ દ્વારા WhatsApp Business વૃદ્ધિને પહોંચમાં લાવે છે હવે 
      <span class="underline decoration-[#00D084] underline-offset-4">Meta વેરિફાઇડના</span> વધારાના વિશ્વાસ સાથે`,
    filterOptions: [
      { label: "બધા", value: "all" },
      { label: "એડ્સ  ધેટ ક્લિક ટુ WhatsApp", value: "ads" },
      { label: "WhatsApp Business ટૂલ", value: "tools" },
    ],
    successStoriesTitle: "સફળતાની વાર્તાઓ શોધો"
  },
}
